/**
 * Create Cart Shipments context for custom hook
 */


import { createContext } from 'react'

const CartShipmentsContext = createContext({
  fetchCartShipmentAvailableDeliveryDates: () => {},
  fetchCartShipmentAvailableDeliveryTimeSlots: () => {},
  fetchCartShipmentAvailablePickupStores: () => {},
  fetchCartShipmentAvailablePickupStoresAll: () => {},
  fetchCartShipmentCourierServices: () => {},
  fetchCartShipmentCourierServicesAll: () => {},
})

export default CartShipmentsContext
